cv.photo = function (params) {
  // Default photo
  if (_.has(params, "photo_default") && params.photo_default != "") {
    var photo_path = params.photo_default;

    if (params.photo_default.split("-")[0] == "avatar") {
      var default_avatars = [
        "/default_avatars/Origami_Animals_C_bird.png",
        "/default_avatars/Origami_Animals_C_chicken.png",
        "/default_avatars/Origami_Animals_C_cat.png",
        "/default_avatars/Origami_Animals_C_crab.png",
        "/default_avatars/Origami_Animals_C_dolphin.png",
        "/default_avatars/Origami_Animals_C_fish.png",
        "/default_avatars/Origami_Animals_C_fox.png",
        "/default_avatars/Origami_Animals_C_frog.png",
        "/default_avatars/Origami_Animals_C_giraffe.png",
        "/default_avatars/Origami_Animals_C_gorilla.png",
        "/default_avatars/Origami_Animals_C_panda.png",
        "/default_avatars/Origami_Animals_C_parrot.png",
        "/default_avatars/Origami_Animals_C_penguin.png",
        "/default_avatars/Origami_Animals_C_pig.png",
        "/default_avatars/Origami_Animals_C_rabbit.png",
        "/default_avatars/Origami_Animals_C_swan.png",
      ];
      if (_.isUndefined(params.photo_default.split("-")[1])) {
        photo_path = "/default_avatars/Origami_Animals_C_bird.png";
      } else {
        var avatar_index = Math.abs(cv.hashCode(params.photo_default.split("-")[1])) % 16;
        photo_path = default_avatars[avatar_index];
      }
    }
  } else {
    var photo_path = "/transparent_pixel.png";
  }

  // Real photo and replace paths
  if (
    _.has(params, "photo_path") &&
    !_.isNull(params.photo_path) &&
    !_.isUndefined(params.photo_path) &&
    params.photo_path != ""
  ) {
    photo_path = params.photo_path;

    if (photo_path.indexOf("http://") == 0 || photo_path.indexOf("https://") == 0) {
      return photo_path;
    }
  }

  // Rewrite paths
  photo_path = cv.removeBaseUrl(photo_path);
  photo_path = photo_path.replace("/_resources/images/uploads/", "/images/");
  photo_path = photo_path.replace("/_resources/images/", "/images/");
  photo_path = photo_path.replace("causevox-staging/", "");

  // Transforms
  if (_.has(params, "transforms")) {
    var transforms = "?" + $.param(params.transforms);
  } else {
    var transforms = "";
  }

  // Classes to add
  if (_.has(params, "classes")) {
    var classes = params.classes;
  } else {
    var classes = "";
  }

  // Return url only or full photo
  if (_.has(params, "url_only")) {
    var url_only = params.url_only;
  } else {
    var url_only = false;
  }

  if (url_only === true) {
    return "https://cvox.imgix.net" + photo_path + transforms;
  } else {
    return (
      '<img class="imgix-fluid ' +
      classes +
      '" src="https://cvox.imgix.net' +
      photo_path +
      transforms +
      '" />'
    );
  }
};

cv.hashCode = function (s) {
  for (var i = 0, h = 0; i < s.length; i++) h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  return h;
};
